module.exports = __webpack_public_path__ + "3b3dbf904de01d22336f0cc2912328bb.pdf";